import gql from 'graphql-tag';

import cardElementDetails from '../../../../services/cards/graphql/fragments/cardElementDetails';

export const cardElementCreate = gql`
  mutation cardElementCreate($input: CardElementCreateInput!) {
    cardElementCreate(input: $input) {
      card_element {
        ...cardElementDetails
      }
    }
  }
  ${cardElementDetails}
`;

export const cardElementUpdate = gql`
  mutation cardElementUpdate($input: CardElementUpdateInput!) {
    cardElementUpdate(input: $input) {
      card_element {
        ...cardElementDetails
      }
    }
  }
  ${cardElementDetails}
`;
